// @ts-nocheck
import React, { memo } from 'react'
import uuid from 'uuid/v4'
import { filePromises } from 'utils/fileUploadHelper'
import { AddedDocuments } from './AddedDocuments'
import { EditedPackageFilesRow } from './EditedPackageFilesRow'

interface IEditPackageFilesRowProps {
  dialogDocuments: {
    createdAt: string
    fileFileName: string
    fileUrl: string
    file: string
    id: string
  }[]
  addDocUpload: (...args: any[]) => any
  deleteDocUpload: (...args: any[]) => any
}

export const EditPackageFilesRow: React.FunctionComponent<IEditPackageFilesRowProps> = memo(
  ({ addDocUpload, deleteDocUpload, dialogDocuments }) => {
    const onChange = e => {
      const files = [...e.target.files]
      Promise.all(filePromises(files)).then(packageFiles => {
        addDocUpload(
          packageFiles.map(packageFile => ({
            ...packageFile,
            id: uuid(),
            pending: true,
          }))
        )
      })
    }
    return (
      <>
        <div className='pv5'>
          <div className='row no-gutter'>
            <div className='col-xs-4 col-md-3'>
              <label
                className='btn-fileinput btn'
                htmlFor='file-upload'
                id='file-upload'
                data-test='upload-files'>
                <input
                  type='file'
                  id='uploads'
                  name='uploads'
                  accept='.pdf, .jpg, .jpeg, .png, .doc, .docx, .tiff, .txt'
                  onChange={onChange}
                  multiple
                />
                Upload
              </label>
            </div>
          </div>
          <div className='pv1'>
            {!dialogDocuments.length && (
              <span>
                <p>No documents have been uploaded yet.</p>
              </span>
            )}
          </div>
        </div>

        {dialogDocuments
          .filter(({ _destroy }) => !_destroy)
          .map(doc =>
            doc.fileFileName ? (
              <AddedDocuments key={doc.file} document={doc} />
            ) : (
              <EditedPackageFilesRow
                key={document.fileUrl}
                document={doc}
                deleteDocUpload={deleteDocUpload}
              />
            )
          )}
      </>
    )
  }
)
